// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "sso-app." + {"283":"288ae6eccdb4308c3d56","434":"5e695baec26559a1b3c4","536":"76024f7ddc50f9e11b91","566":"acf37bdb427cb58629b9","657":"8164eded2a61d8b86ba8"}[chunkId] + ".js";
};